export default __webpack_public_path__ + "static/media/calendar.bd630550.svg";